import { useApp } from '@hb/react'
import { useProfile } from '../../contexts/user/ProfileContext'
import { GynCareViewProvider } from '../../components/Gyn/context'
import { LaborCharting } from './LaborCharting'

export const PregnancyChartingView = () => {
  const { userId, user, assessmentId } = useProfile()
  const { appName } = useApp()

  if (!userId || !user || !assessmentId) return null

  return (
    <GynCareViewProvider user={user} admin canChangePractice={appName === 'app'}>
      <LaborCharting patientId={userId} assessmentId={assessmentId} />
    </GynCareViewProvider>
  )
}
